import { useMemo } from "react";
import { Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useToast } from "../../../../../context/toast";
import { useStudents } from "../../../../../context/students";
import { useTranslate } from "../../../../../hooks/useTranslate";
import Select from "../../../../../components/Select";
import Preloader from "../../../../../components/Preloader";
import SummaryBox from "../../../../../components/SummaryBox";
import axiosManager from "../../../../../services/axiosManager";

const StartDateBlock = (props) => {
    const {
        isOpen, onClose,
        studentFullName,
        startDatesOptions, isLoadingStartDates,
        disabled,
        startDate, changeStartDate,
    } = props;
    const { t } = useTranslate();
    const toast = useToast();
    const { activeStudentId, refetchStudent } = useStudents();

    const hasStartInOptions = useMemo(() => (startDatesOptions || []).some((it) => it.value === startDate), [startDate, startDatesOptions]);
    const start = useMemo(() => (startDatesOptions || []).find((it) => it.value === startDate)?.label, [startDate, startDatesOptions]);

    const { mutateAsync: updateStartDate, isPending: isUpdatingStartDate } = useMutation({
        mutationFn: (newStartDate) => axiosManager.put$(`/parent/api/students/${activeStudentId}/StartDate`, newStartDate),
        onError: () => toast.error(t("common.errorMessage")),
    });

    const onUpdateStartDate = async (value) => {
        changeStartDate(value);
        await updateStartDate(value);
        onClose();
        refetchStudent();
    };

    return (
        <SummaryBox isFormBox showBorder={isOpen}>
            <Preloader
                isLoading={isLoadingStartDates || isUpdatingStartDate}
                overflow
                showInitiallyOverflow
            >
                <div className="flex xs:flex-column align-center justify-between gap-4">
                    <div>
                        <Typography variant="h4" className="text-primary">
                            {t("tuitionBilling.desiredStartDateTitle", { start: start || "-" })}
                        </Typography>
                        <Typography variant="body1" className="mt-2">
                            {t("tuitionBilling.desiredStartDateSubTitle", { studentName: studentFullName })}
                        </Typography>
                    </div>
                    <div className="change-start-date">
                        <Select
                            label={t("tuitionBilling.desiredStartDateLabel")}
                            name="startDate"
                            disabled={isLoadingStartDates || disabled || isUpdatingStartDate}
                            options={startDatesOptions}
                            value={startDate}
                            onChange={onUpdateStartDate}
                            error={!hasStartInOptions ? t("tuitionBilling.desiredStartDateError") : undefined}
                        />
                    </div>
                </div>
            </Preloader>
        </SummaryBox>
    );
};

export default StartDateBlock;
